module.exports = __webpack_public_path__ + "assets/img/026501.db39fa2c.svg";